export default function route(page) {
  switch (page) {
    case 'connection':
      import('./pages/connection')
      return page

    case 'scenario':
      import('./pages/scenario')
      return page

    case 'integration-monitor':
      import('./pages/integration-monitor')
      return page

    case 'state-register-page':
      import('./pages/state-register')
      return page

    case 'integration-analysis':
      import('./pages/integration-analysis')
      return page
  }
}
